<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild
            :settings="fields.settings"
            :container-page="fields.containerPage"
            :use-background-mobile="true"
          />
        </div>

        <div class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Features</label>
            <v-btn small text color="primary" @click="handleAddFeature">
              <v-icon size="16">mdi-plus</v-icon>
              Add Feature
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(feature, featureIndex) in fields.features" :key="`feature-${featureIndex}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Feature {{ featureIndex + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveFeature(featureIndex)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <label class="field-label">Desktop Image</label>
                      <UploadImage
                        :image="{ imageSrc: feature.desktopImage }"
                        :height="`180`"
                        :typeUpload="'image'"
                        @callback="obj => handleUploadFeatureImage(featureIndex, 'desktopImage', obj)"
                        @callbackDelete="handleRemoveFeatureImage(featureIndex, 'desktopImage')"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <label class="field-label">Mobile Image</label>
                      <UploadImage
                        :image="{ imageSrc: feature.mobileImage }"
                        :height="`180`"
                        :typeUpload="'image'"
                        @callback="obj => handleUploadFeatureImage(featureIndex, 'mobileImage', obj)"
                        @callbackDelete="handleRemoveFeatureImage(featureIndex, 'mobileImage')"
                      />
                    </v-col>
                  </v-row>

                  <label class="field-label mt-4">Title</label>
                  <ckeditor :editor="editor" v-model="feature.title" :config="editorConfig" />

                  <div class="d-flex justify-space-between align-center mt-5 mb-2">
                    <label class="field-label mb-0">Tags</label>
                    <v-btn small text color="primary" @click="handleAddTag(featureIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      Add Tag
                    </v-btn>
                  </div>
                  <div v-for="(tag, tagIndex) in feature.tags" :key="`tag-${featureIndex}-${tagIndex}`" class="tag-row">
                    <v-text-field
                      :value="tag"
                      :label="`Tag ${tagIndex + 1}`"
                      hide-details
                      @input="value => handleUpdateTag(featureIndex, tagIndex, value)"
                    />
                    <v-btn icon @click="handleRemoveTag(featureIndex, tagIndex)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <label class="field-label mt-4">Description</label>
                  <ckeditor :editor="editor" v-model="feature.description" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const DEFAULT_FEATURE = {
  desktopImage: '',
  mobileImage: '',
  title: '<p>40% CONCENTRATION</p><h3>Peppermint Oil</h3>',
  tags: ['Nerve-trigger'],
  description: "<p>Forces mice's survival instinct to fire. Instantly.</p>",
};

const DEFAULT_BUTTON = {
  show: true,
  text: 'ADD TO CART',
  link: '#',
  backgroundColor: '#CCF46F',
  color: '#23372B',
  radius: 999,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: '',
  },
  subBtn: { show: true, text: '30-Day Money Back Guarantee' },
};

const clone = value => JSON.parse(JSON.stringify(value));

export default {
  name: 'SofyreIngredientsSectionEditor',
  components: { ButtonPrimary, SectionSettingsContainerFuild, UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Sofyre ingredients',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#000000',
          textColor: '#F7F7F0',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: true,
          backgroundImageMobile: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        header: '',
        features: [],
        button: clone(DEFAULT_BUTTON),
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value && value.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      const extractedButton = extract.button || {};
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        features: Array.isArray(extract.features) ? clone(extract.features) : [],
        button: {
          ...this.fields.button,
          ...extractedButton,
          iconPrefix: { ...this.fields.button.iconPrefix, ...(extractedButton.iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...(extractedButton.iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...(extractedButton.subBtn || {}) },
        },
      };
    },
    handleAddFeature() {
      this.fields.features.push(clone(DEFAULT_FEATURE));
    },
    handleRemoveFeature(index) {
      this.fields.features.splice(index, 1);
    },
    handleUploadFeatureImage(index, key, obj) {
      this.$set(this.fields.features[index], key, (obj && obj.imageSrc) || '');
    },
    handleRemoveFeatureImage(index, key) {
      this.$set(this.fields.features[index], key, '');
    },
    handleAddTag(featureIndex) {
      const feature = this.fields.features[featureIndex];
      if (!Array.isArray(feature.tags)) this.$set(feature, 'tags', []);
      feature.tags.push('New tag');
    },
    handleUpdateTag(featureIndex, tagIndex, value) {
      this.$set(this.fields.features[featureIndex].tags, tagIndex, value);
    },
    handleRemoveTag(featureIndex, tagIndex) {
      this.fields.features[featureIndex].tags.splice(tagIndex, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionSofyreIngredients(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px !important;
  font-weight: 500;
}
.field-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.tag-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.header-modal {
  top: 0;
}
.footer-modal {
  bottom: 0;
}
</style>
